<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { fetchMarketplaceJson } from 'dashboard/helpers/marketplaceApi';
import OrderDeductionsPanel from '../components/OrderDeductionsPanel.vue';

// Toptan (B2B) > Siparişler — Adrom Shopify siparişlerinin ana ekranı.
// Sipariş anında webhook'la kuyruğa düşer; buradan onaylanıp Ticimax'e işlenir.
const route = useRoute();
const accountId = route.params.accountId;

const loading = ref(true);
const error = ref('');
const channels = ref([]);

const shopifyChannel = computed(() =>
  channels.value.find(c => c.channelType === 'shopify_adrom')
);

onMounted(async () => {
  try {
    const data = await fetchMarketplaceJson(accountId, 'channels');
    channels.value = data.channels || [];
  } catch (e) {
    error.value = 'Kanal bilgisi yüklenemedi: ' + e.message;
  } finally {
    loading.value = false;
  }
});
</script>

<template>
  <div
    class="flex flex-col h-full flex-1 min-w-0 overflow-hidden bg-slate-50 dark:bg-slate-900"
  >
    <div
      class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800 bg-white dark:bg-slate-900 shrink-0"
    >
      <div>
        <h1 class="text-lg font-semibold text-slate-900 dark:text-slate-100">
          Siparişler
        </h1>
        <p class="text-xs text-slate-400">
          Adrom Toptan (Shopify) · sipariş anında düşer → onayınla Ticimax’e
          adet satışı yazılır
        </p>
      </div>
    </div>

    <div class="flex-1 overflow-auto p-5">
      <div
        v-if="loading"
        class="flex h-48 items-center justify-center gap-2 text-slate-400"
      >
        <span class="i-lucide-loader-2 size-5 animate-spin" />
        <span class="text-sm">Yükleniyor…</span>
      </div>
      <div
        v-else-if="error"
        class="flex items-center gap-3 rounded-xl bg-red-50 dark:bg-red-950 p-4 text-sm text-red-600 dark:text-red-400"
      >
        <span class="i-lucide-alert-circle size-5 shrink-0" />
        {{ error }}
      </div>
      <div
        v-else-if="!shopifyChannel"
        class="text-center text-sm text-slate-400 py-12"
      >
        Shopify kanalı bağlı değil — Entegrasyonlar sayfasından kanal kurulmalı.
      </div>
      <OrderDeductionsPanel v-else :channel-id="shopifyChannel.id" />
    </div>
  </div>
</template>
